
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.534 14H4.165a.651.651 0 01-.643-.559L2.3 4.9h9.1l-1.222 8.541a.651.651 0 01-.644.559zM1.325 4.9h11.05M5.55 7.5v3.9M8.15 7.5v3.9M9.45 2.95h-5.2l1.105-1.658A.658.658 0 015.901 1h1.905c.214 0 .422.11.539.292L9.45 2.95zM1 2.95h11.7","stroke":"#221B38","stroke-width":"1.2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    